import React from 'react';
import Lazy from '@prisjakt/ui-lazy';
import { PrismicImage } from '../../../../../types';
import * as S from './styles';

type Props = {
  className?: string;
} & PrismicImage;

const Image = ({ className, url, alt }: Props) =>
  url ? (
    <S.Image className={className}>
      <figure>
        <Lazy loadOnIdle>
          <img src={url} alt={alt || ''} />
        </Lazy>
        {Boolean(alt) && <figcaption>{alt}</figcaption>}
      </figure>
    </S.Image>
  ) : null;

export default Image;
